import type { components } from "@/api/schema";
import { atom } from "jotai";
import { atomWithStorage, createJSONStorage } from "jotai/utils";

type ConsoleProfileData = components["schemas"]["ConsolesListOutput"] | null;

/** Whether the user has already seen the "what is a console profile?" intro. */
export const consoleProfileIntroSeenAtom = atom<boolean>(false);

export const USER_CONSOLE_KEY = "FCUserConsole" as const;

export const userConsoleAtom = atomWithStorage<ConsoleProfileData>(
	USER_CONSOLE_KEY,
	null,
	createJSONStorage(() => localStorage),
);
